import React, { useState, useEffect } from "react";
import Card from "../Common/Card";
import ajaxDashboard from "../../util/remote/ajaxDashboard";
const CardsComponent = () => {
  const [pendingReqCount, setPendingReqCount] = useState(0);
  const [pendingPOCount, setPendingPOCount] = useState(0);
  const [pendingInvoiceCount, setPendingInvoiceCount] = useState(0);
  const [activeSuppliersCount, setActiveSuppliersCount] = useState(0);
  const [activeUsersCount, setActiveUsersCount] = useState(0);
  const [allDepartmentsCount, setAllDepartmentsCount] = useState(0);
  useEffect(() => {
    // Fetch pending requisitions
    const fetchPendingReqCount = async () => {
      try {
        const count = await ajaxDashboard.getPendingReqCount();
        setPendingReqCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching pending request count:", error);
      }
    };
    // Fetch pending purchase orders
    const fetchPendingPOCount = async () => {
      try {
        const count = await ajaxDashboard.getCountPendingPurchaseOrders();
        setPendingPOCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching pending PO count:", error);
      }
    };
    // Fetch pending invoices
    const fetchPendingInvoiceCount = async () => {
      try {
        const count = await ajaxDashboard.getCountPendingInvoices();
        setPendingInvoiceCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching pending invoice count:", error);
      }
    };
    // Fetch active suppliers
    const fetchActiveSuppliersCount = async () => {
      try {
        const count = await ajaxDashboard.getCountActiveSuppliers();
        setActiveSuppliersCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching active suppliers count:", error);
      }
    };
    // Fetch active users
    const fetchActiveUsersCount = async () => {
      try {
        const count = await ajaxDashboard.getCountActiveUsers();
        setActiveUsersCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching active users count:", error);
      }
    };
    // Fetch all departments
    const fetchAllDepartmentsCount = async () => {
      try {
        const count = await ajaxDashboard.getCountAllDepartments();
        setAllDepartmentsCount(Number(count) || 0);
      } catch (error) {
        console.error("Error fetching all departments count:", error);
      }
    };
    // Call all fetch functions independently
    fetchPendingReqCount();
    fetchPendingPOCount();
    fetchPendingInvoiceCount();
    fetchActiveSuppliersCount();
    fetchActiveUsersCount();
    fetchAllDepartmentsCount();
  }, []);
  return (
    <div className="row row-sm">
      <Card
        value={pendingReqCount}
        color={"blue"}
        icon={"fa-solid fa-clipboard-check"}
        details={"Pending  Approvals"}
        details1={"pending requisition approvals"}
        perc={"*"}
        percd={"e"}
      />
      <Card
        value={pendingPOCount}
        color={"blue"}
        icon={"fa-solid fa-truck-loading"}
        details={"Pending Orders"}
        details1={"Total of orders pending delivery"}
        perc={"*"}
        percd={"d"}
      />
      <Card
        value={pendingInvoiceCount}
        color={"blue"}
        icon={"fa-solid fa-file-invoice-dollar"}
        details={"Pending Invoice Payment"}
        details1={"Number of invoices not yet paid"}
        perc={"*"}
        percd={"d"}
      />
      <Card
        value={activeSuppliersCount}
        color={"blue"}
        icon={"fa-solid fa-people-carry-box"}
        details={"Active Suppliers"}
        details1={"Total of active suppliers"}
        perc={"*"}
        percd={"e"}
      />
      <Card
        value={activeUsersCount}
        color={"blue"}
        icon={"fa-solid fa-users"}
        details={"Active Users"}
        details1={"Number of active system users"}
        perc={"*"}
        percd={"e"}
      />
      <Card
        value={allDepartmentsCount}
        color={"blue"}
        icon={"fa-solid fa-sitemap"}
        details={"Departments"}
        details1={"Number of departments"}
        perc={"*"}
        percd={"e"}
      />
    </div>
  );
};
export default CardsComponent;
